var _defs, _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBracoDeLampada = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 2.14px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #171954;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-width: 2.03px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m32.96,28.6H8.51v-3.97h25.68c9.38,5.34,18.75,10.67,28.13,16.01v4.22c-9.79-5.42-19.57-10.84-29.36-16.26Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 62.43,
    y: 25.99,
    width: 4.06,
    height: 27.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.32,30.53c-1.84,2.28-3.68,4.55-5.52,6.83,1.84,1.09,3.68,2.19,5.52,3.28v-10.11Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBracoDeLampada);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BRACO_DE_LAMPADA.fc7578c33598b7c74424f1f0df95726f.svg";